import * as attachmentsModule from '@/store/attachments/attachmentsModule'

export const state = Object.assign({}, attachmentsModule.defaults())

export default {
  namespaced: true,
  state,
  mutations: attachmentsModule.mutations,
  actions: attachmentsModule.actions,
  getters: attachmentsModule.getters
}



// WEBPACK FOOTER //
// ./src/store/assets/drivers/driverAttachmentsModel.js